module.exports = {
  statements: {
    verbs: [
      { en: "i like", es: "me gusta" },
      { en: "you like", es: "te gusta" },
      { en: "we like", es: "nos gusta" },
      { en: "he likes", es: "el le gusta" },
      { en: "she likes", es: "a ella le gusta" },
      { en: "i want", es: "quiero" },
      { en: "you want", es: "quieres" },
      { en: "we want", es: "nosotros queremos" },
      { en: "he wants", es: "el quiere" },
      { en: "she wants", es: "ella quiere" },
      { en: "i would like", es: "me gustaria" },
      { en: "you would like", es: "te gustaria" },
      { en: "we would like", es: "nos gustaria" },
      { en: "he would like", es: "a el le gustaria" },
      { en: "she would like", es: "a ella le gustaria" }
    ]
  },
  actions: {
    infinitives: [
      { en: "to play with", es: "jugar con" },
      { en: "to eat", es: "comer" },
      { en: "to drink", es: "beber" },
      { en: "to see", es: "ver" }
    ]
  },
  categories: {
    animals: [
      { en: "cow(s)", es: { prefix: "la", noun: "vaca", plural: "vacas" } },
      { en: "sheep", es: { prefix: "la", noun: "vaca", plural: "oveja" } },
      { en: "dog(s)", es: { prefix: "el", noun: "perro", plural: "perros" } },
      { en: "cat(s)", es: { prefix: "el", noun: "gato", plural: "gatos" } },
      { en: "fox(es)", es: { prefix: "el", noun: "zorro", plural: "zorros" } },
      { en: "tiger(s)", es: { prefix: "el", noun: "tigre", plural: "tigres" } },
      {
        en: "elephant(s)",
        es: { prefix: "el", noun: "elefante", plural: "elefantes" }
      },
      {
        en: "rabbit(s)",
        es: { prefix: "el", noun: "conejo", plural: "conejos" }
      },
      {
        en: "horse(s)",
        es: { prefix: "el", noun: "caballo", plural: "caballos" }
      },
      {
        en: "turtle(s)",
        es: { prefix: "la", noun: "tortuga", plural: "tortugas" }
      }
    ],
    foods: [
      {
        en: "sandwich(es)",
        es: { prefix: "la", noun: "bocadillo", plural: "bocadillos" }
      },
      {
        en: "burger(s)",
        es: { prefix: "la", noun: "hamburguesa", plural: "hamburguesas" }
      }
    ]
  },
  nouns: {
    buildings: [
      { en: "in a shop", es: "en una tienda" },
      { en: "in a garage", es: "en un garaje" },
      { en: "in a stadium", es: "en un sstadio" },
      { en: "in a church", es: "en una iglesia" },
      { en: "in a house", es: "en una casa" },
      { en: "in a cinema", es: "en una cine" },
      { en: "in a theatre", es: "en un teatro" },
      { en: "in a library", es: "en una biblioteca" },
      { en: "in a post office", es: "en una oficial postal" },
      { en: "in a school", es: "en una escuela" },
      { en: "in a bank", es: "en un banco" },
      { en: "in an airport", es: "en un aeropuerto" },
      { en: "in a factory", es: "en una fabrica" }
    ]
  },
  adjectives: {
    sizes: [
      { en: "big", es: { noun: "grande", plural: "grandes" } },
      { en: "small", es: { noun: "pequeno", plural: "pequenos" } }
    ],
    colours: [
      { en: "yellow", es: { noun: "amarillo", plural: "amarillas" } },
      { en: "blue", es: { noun: "azul", plural: "azules" } },
      { en: "green", es: { noun: "verde", plural: "verdes" } },
      { en: "orange", es: { noun: "naranja", plural: "naranjas" } },
      { en: "brown", es: { noun: "marron", plural: "marrones" } },
      { en: "red", es: { noun: "rojo", plural: "rojos" } },
      { en: "pink", es: { noun: "rosa", plural: "rosados" } },
      { en: "purple", es: { noun: "morado", plural: "morados" } },
      { en: "black", es: { noun: "negro", plural: "negros" } },
      { en: "white", es: { noun: "blanco", plural: "blancos" } },
      { en: "gray", es: { noun: "gris", plural: "grises" } },
      { en: "gold", es: { noun: "dorado", plural: "dorados" } },
      { en: "silver", es: { noun: "plateado", plural: "plateados" } }
    ]
  },
  labels: {
    numbers: [
      { en: "zero", es: { noun: "cero", plural: "cero" } },
      { en: "one", es: { noun: "uno", plural: "uno" } },
      { en: "two", es: { noun: "dos", plural: "dos" } },
      { en: "three", es: { noun: "tres", plural: "tres" } },
      { en: "four", es: { noun: "cuatro", plural: "cuatro" } },
      { en: "five", es: { noun: "cinco", plural: "cinco" } },
      { en: "six", es: { noun: "seis", plural: "seis" } },
      { en: "seven", es: { noun: "siete", plural: "siete" } },
      { en: "eight", es: { noun: "ocho", plural: "ocho" } },
      { en: "nine", es: { noun: "nueve", plural: "nueve" } },
      { en: "ten", es: { noun: "diez", plural: "diez" } },
      { en: "eleven", es: { noun: "once", plural: "once" } },
      { en: "twelve", es: { noun: "doce", plural: "doce" } },
      { en: "thirteen", es: { noun: "trece", plural: "trece" } },
      { en: "fourteen", es: { noun: "catorce", plural: "catorce" } },
      { en: "fifteen", es: { noun: "quince", plural: "quince" } },
      { en: "sixteen", es: { noun: "dieciseis", plural: "dieciseis" } },
      { en: "seventeen", es: { noun: "diecisiete", plural: "diecisiete" } },
      { en: "eighteen", es: { noun: "dieciocho", plural: "dieciocho" } },
      { en: "nineteen", es: { noun: "diecinueve", plural: "diecinueve" } },
      { en: "twenty", es: { noun: "veinte", plural: "veinte" } },
      { en: "twenty-one", es: { noun: "veintiuno", plural: "veintiuno" } },
      { en: "twenty-two", es: { noun: "veintidos", plural: "veintidos" } },
      { en: "twenty-three", es: { noun: "veintitres", plural: "veintitres" } },
      {
        en: "twenty-four",
        es: { noun: "veinticuatro", plural: "veinticuatro" }
      },
      { en: "twenty-five", es: { noun: "veinticinco", plural: "veinticinco" } },
      { en: "twenty-six", es: { noun: "veintiseis", plural: "veintiseis" } },
      {
        en: "twenty-seven",
        es: { noun: "veintisiete", plural: "veintisiete" }
      },
      { en: "twenty-eight", es: { noun: "veintiocho", plural: "veintiocho" } },
      { en: "twenty-nine", es: { noun: "veintinueve", plural: "veintinueve" } },
      { en: "thirty", es: { noun: "treinta", plural: "treinta" } },
      {
        en: "thirty-one",
        es: { noun: "treinta y uno", plural: "treinta y uno" }
      },
      {
        en: "thirty-two",
        es: { noun: "treinta y dos", plural: "treinta y dos" }
      },
      {
        en: "thirty-three",
        es: { noun: "treinta y tres", plural: "treinta y tres" }
      },
      {
        en: "thirty-four",
        es: { noun: "treinta y cuatro", plural: "treinta y cuatro" }
      },
      {
        en: "thirty-five",
        es: { noun: "treinta y cinco", plural: "treinta y cinco" }
      },
      {
        en: "thirty-six",
        es: { noun: "treinta y seis", plural: "treinta y seis" }
      },
      {
        en: "thirty-seven",
        es: { noun: "treinta y siete", plural: "treinta y siete" }
      },
      {
        en: "thirty-eight",
        es: { noun: "treinta y ocho", plural: "treinta y ocho" }
      },
      {
        en: "thirty-nine",
        es: { noun: "treinta y nueve", plural: "treinta y nueve" }
      },
      { en: "forty", es: { noun: "cuarenta", plural: "cuarenta" } },
      {
        en: "forty-one",
        es: { noun: "cuarenta y uno", plural: "cuarenta y uno" }
      },
      {
        en: "forty-two",
        es: { noun: "cuarenta y dos", plural: "cuarenta y dos" }
      },
      {
        en: "forty-three",
        es: { noun: "cuarenta y tres", plural: "cuarenta y tres" }
      },
      {
        en: "forty-four",
        es: { noun: "cuarenta y cuatro", plural: "cuarenta y cuatro" }
      },
      {
        en: "forty-five",
        es: { noun: "cuarenta y cinco", plural: "cuarenta y cinco" }
      },
      {
        en: "forty-six",
        es: { noun: "cuarenta y seis", plural: "cuarenta y seis" }
      },
      {
        en: "forty-seven",
        es: { noun: "cuarenta y siete", plural: "cuarenta y siete" }
      },
      {
        en: "forty-eight",
        es: { noun: "cuarenta y ocho", plural: "cuarenta y ocho" }
      },
      {
        en: "forty-nine",
        es: { noun: "cuarenta y nueve", plural: "cuarenta y nueve" }
      },
      { en: "fifty", es: { noun: "cincuenta", plural: "cincuenta" } },
      {
        en: "fifty-one",
        es: { noun: "cincuenta y uno", plural: "cincuenta y uno" }
      },
      {
        en: "fifty-two",
        es: { noun: "cincuenta y dos", plural: "cincuenta y dos" }
      },
      {
        en: "fifty-three",
        es: { noun: "cincuenta y tres", plural: "cincuenta y tres" }
      },
      {
        en: "fifty-four",
        es: { noun: "cincuenta y cuatro", plural: "cincuenta y cuatro" }
      },
      {
        en: "fifty-five",
        es: { noun: "cincuenta y cinco", plural: "cincuenta y cinco" }
      },
      {
        en: "fifty-six",
        es: { noun: "cincuenta y seis", plural: "cincuenta y seis" }
      },
      {
        en: "fifty-seven",
        es: { noun: "cincuenta y siete", plural: "cincuenta y siete" }
      },
      {
        en: "fifty-eight",
        es: { noun: "cincuenta y ocho", plural: "cincuenta y ocho" }
      },
      {
        en: "fifty-nine",
        es: { noun: "cincuenta y nueve", plural: "cincuenta y nueve" }
      },
      { en: "sixty", es: { noun: "sesenta", plural: "sesenta" } },
      {
        en: "sixty-one",
        es: { noun: "sesenta y uno", plural: "sesenta y uno" }
      },
      {
        en: "sixty-two",
        es: { noun: "sesenta y dos", plural: "sesenta y dos" }
      },
      {
        en: "sixty-three",
        es: { noun: "sesenta y tres", plural: "sesenta y tres" }
      },
      {
        en: "sixty-four",
        es: { noun: "sesenta y cuatro", plural: "sesenta y cuatro" }
      },
      {
        en: "sixty-five",
        es: { noun: "sesenta y cinco", plural: "sesenta y cinco" }
      },
      {
        en: "sixty-six",
        es: { noun: "sesenta y seis", plural: "sesenta y seis" }
      },
      {
        en: "sixty-seven",
        es: { noun: "sesenta y siete", plural: "sesenta y siete" }
      },
      {
        en: "sixty-eight",
        es: { noun: "sesenta y ocho", plural: "sesenta y ocho" }
      },
      {
        en: "sixty-nine",
        es: { noun: "sesenta y nueve", plural: "sesenta y nueve" }
      },
      { en: "seventy", es: { noun: "setenta", plural: "setenta" } },
      {
        en: "seventy-one",
        es: { noun: "setenta y uno", plural: "setenta y uno" }
      },
      {
        en: "seventy-two",
        es: { noun: "setenta y dos", plural: "setenta y dos" }
      },
      {
        en: "seventy-three",
        es: { noun: "setenta y tres", plural: "setenta y tres" }
      },
      {
        en: "seventy-four",
        es: { noun: "setenta y cuatro", plural: "setenta y cuatro" }
      },
      {
        en: "seventy-five",
        es: { noun: "setenta y cinco", plural: "setenta y cinco" }
      },
      {
        en: "seventy-six",
        es: { noun: "setenta y seis", plural: "setenta y seis" }
      },
      {
        en: "seventy-seven",
        es: { noun: "setenta y siete", plural: "setenta y siete" }
      },
      {
        en: "seventy-eight",
        es: { noun: "setenta y ocho", plural: "setenta y ocho" }
      },
      {
        en: "seventy-nine",
        es: { noun: "setenta y nueve", plural: "setenta y nueve" }
      },
      { en: "eighty", es: { noun: "ochenta", plural: "ochenta" } },
      {
        en: "eighty-one",
        es: { noun: "ochenta y uno", plural: "ochenta y uno" }
      },
      {
        en: "eighty-two",
        es: { noun: "ochenta y dos", plural: "ochenta y dos" }
      },
      {
        en: "eighty-three",
        es: { noun: "ochenta y tres", plural: "ochenta y tres" }
      },
      {
        en: "eighty-four",
        es: { noun: "ochenta y cuatro", plural: "ochenta y cuatro" }
      },
      {
        en: "eighty-five",
        es: { noun: "ochenta y cinco", plural: "ochenta y cinco" }
      },
      {
        en: "eighty-six",
        es: { noun: "ochenta y seis", plural: "ochenta y seis" }
      },
      {
        en: "eighty-seven",
        es: { noun: "ochenta y siete", plural: "ochenta y siete" }
      },
      {
        en: "eighty-eight",
        es: { noun: "ochenta y ocho", plural: "ochenta y ocho" }
      },
      {
        en: "eighty-nine",
        es: { noun: "ochenta y nueve", plural: "ochenta y nueve" }
      },
      { en: "ninety", es: { noun: "noventa", plural: "noventa" } },
      {
        en: "ninety-one",
        es: { noun: "noventa y uno", plural: "noventa y uno" }
      },
      {
        en: "ninety-two",
        es: { noun: "noventa y dos", plural: "noventa y dos" }
      },
      {
        en: "ninety-three",
        es: { noun: "noventa y tres", plural: "noventa y tres" }
      },
      {
        en: "ninety-four",
        es: { noun: "noventa y cuatro", plural: "noventa y cuatro" }
      },
      {
        en: "ninety-five",
        es: { noun: "noventa y cinco", plural: "noventa y cinco" }
      },
      {
        en: "ninety-six",
        es: { noun: "noventa y seis", plural: "noventa y seis" }
      },
      {
        en: "ninety-seven",
        es: { noun: "noventa y siete", plural: "noventa y siete" }
      },
      {
        en: "ninety-eight",
        es: { noun: "noventa y ocho", plural: "noventa y ocho" }
      },
      {
        en: "ninety-nine",
        es: { noun: "noventa y nueve", plural: "noventa y nueve" }
      },
      { en: "one hundred", es: { noun: "cien", plural: "cien" } }
    ]
  }
};
